import type { CurrencyCode, Navigation } from '@noths/polaris-dev-ts-types';
import type { SerializedError } from '@reduxjs/toolkit';

import type { ReduxProductsCategory } from 'src/redux/products/types/reduxProductsCategory';
import type { Filter } from 'src/redux/productsQuery/types/Filter';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';
import type { Partner } from 'src/types/partner';
import type { Product } from './types/Product';

export enum TriggerName {
  CHANGE_FILTERS = 'changeFilters',
  CHANGE_SORT = 'changeSort',
  LOAD_MORE_PRODUCTS = 'loadMoreProducts',
  LOAD_PREVIOUS_PRODUCTS = 'loadPreviousProducts',
}

export interface ProviderMetadata {
  filter: string;
  pageCategories: string[];
}

// return format of adapter
export interface RequestProductsActionProductsPayload {
  category: ReduxProductsCategory | null;
  currencyCode: CurrencyCode;
  errorCode?: string;
  errorMessage?: string;
  lastPageLoaded: number;
  navigation: Navigation[];
  partner?: Partner | null;
  perPage: number;
  pinnedResultCount?: number;
  products: Product[];
  productsReturnedCount: number;
  providerAttributionToken: string | null;
  providerMetadata: ProviderMetadata | null;
  queryType: string | null;
  term: string | null;
  totalPages: number;
  totalProducts: number;
  zeroExactResults?: boolean;
}

// return format of requestProducts thunk; used in reducer
export interface RequestProductsActionPayload {
  filters?: Filter[];
  products?: RequestProductsActionProductsPayload;
  redirectUrl?: string;
  sortOptions?: SortOption[];
  triggerName?: TriggerName;
}

export interface ProductsState {
  category: ReduxProductsCategory | null;
  currencyCode: CurrencyCode;
  deliveryZone?: string;
  error?: SerializedError | null;
  initialProductPage?: number;
  lastPageLoaded: number | null;
  navigation: Navigation[];
  pageLoading: number | null;
  pages: Record<number, Product[]>;
  partner?: Partner;
  pinnedResultCount?: number | null;
  productsReturnedCount: number;
  providerAttributionToken: string | null;
  providerMetadata: ProviderMetadata | null;
  queryType: string;
  redirectUrl?: string;
  showFewResultsMessage?: boolean;
  totalPages: number;
  totalProducts: number;
  zeroExactResults?: boolean | null;
}
